import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { WidgetService } from 'src/app/services/widget.service';
import { DatasetsService } from 'src/app/services/datasets.service';
import { RawComponent } from '../../data/raw/raw.component';

@Component({
    selector: 'app-raw-data-widget',
    templateUrl: './raw-data-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './raw-data-widget.component.scss'],
    standalone: false
})
export class RawDataWidgetComponent extends BaseWidgetComponent implements OnInit {
  @ViewChild(RawComponent) rawComponent!: RawComponent;

  public datasets: string[] = [];
  public isLoading: boolean = true;

  constructor(
    private _widgetService: WidgetService,
    private _datasetsService: DatasetsService
  ) {
    super();
  }

  ngOnInit(): void {
    this._datasetsService.loadAsync(this.teamName).then((results) => {
      this.isLoading = false;
      if (!results) return;

      this.datasets = results.sort((a, b) => a.localeCompare(b));
    });

    this._subs.add = this._widgetService.resize$.subscribe(() => {
      setTimeout(() => {
        this.rawComponent?.optimizePageSize();
      }, 100);
    });
  }

  onViewData(input: any) {
    const widget = this._widgetService.createWidget('DataViewerWidget', this.teamName, {}, {
      defaultSpace: { rows: 35, cols: 55 },
      baseInputs: {
        path: input.path,
        fileType: input.fileType
      },
      outputs: {
        onClose: ($event: BaseWidgetComponent.Event) => {
          setTimeout(() => this._widgetService.removeWidget(this.teamName, $event.id));
        },
        onRestore: ($event: BaseWidgetComponent.Event) => {
          this._widgetService.restoreWidget(this.teamName, $event.id);
        },
        onMaximize: ($event: BaseWidgetComponent.Event) => {
          this._widgetService.maximizeWidget(this.teamName, $event.id);
        },
        onToggle: ($event: BaseWidgetComponent.Event) => {
          this._widgetService.toggleWidget(this.teamName, $event.id);
        },
        onDock: ($event: BaseWidgetComponent.DockEvent) => {
          this._widgetService.dockWidget(this.teamName, $event.id, $event.position);
        },
        onUndock: ($event: BaseWidgetComponent.Event) => {
          this._widgetService.undockWidget(this.teamName, $event.id);
        }
      }
    });
    this._widgetService.addWidget(this.teamName, widget);
  }
}
